// extracted by mini-css-extract-plugin
export default {"content":"Pack_content__3QNB+","title":"Pack_title__1tjht","col":"Pack_col__RkaMi","footer":"Pack_footer__XG71d"};